import { render } from "./HistoricalItem.vue?vue&type=template&id=29cfaab1&scoped=true"
import script from "./HistoricalItem.vue?vue&type=script&lang=js"
export * from "./HistoricalItem.vue?vue&type=script&lang=js"

import "./HistoricalItem.vue?vue&type=style&index=0&id=29cfaab1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cfaab1"]])

export default __exports__